import { createContext } from "react";
import type { ValidationGroupContextType } from "@/types/Validations";

export const ValidationGroupContext =
  createContext<ValidationGroupContextType | null>(null);
